import type { Event } from '@patsnap/tahiti-core';
import type { EurekaAmountsControl } from '@telecom/shared/domain/permission/apis/eureka-amounts-control-api';

/**
 * Eureka 权益控制服务
 *
 * 负责获取、缓存 Eureka 权益菜单控制配置，并对外提供同步读取能力。
 * 抽离为 service 后，非 Vue 的纯 JS 模块（如其它 service）也可复用其状态，
 * 不再依赖只能在组件中使用的 composable。
 */
export abstract class EurekaAmountsControlService {
    /**
     * 权益控制配置变化事件
     */
    abstract readonly onAmountsControlChange: Event<void>;

    /**
     * 获取当前缓存的权益控制配置，未加载时为 null
     */
    abstract getAmountsControl(): EurekaAmountsControl | null;

    /**
     * 是否正在加载权益控制配置
     */
    abstract isLoading(): boolean;

    /**
     * 是否为免费用户
     * 判断逻辑：权益控制配置中的 freemium 字段为 true
     */
    abstract isFreeUser(): boolean;

    /**
     * 是否有积分套餐权益
     * 判断逻辑：权益控制配置中的 credit_package 字段为 true
     */
    abstract hasCreditPackage(): boolean;

    /**
     * 拉取并缓存权益控制配置，已在加载中时复用同一请求
     */
    abstract syncAmountsControl(): Promise<void>;

    /**
     * 确保配置已加载，已有缓存时直接返回，否则触发一次拉取
     */
    abstract ensureLoaded(): Promise<void>;
}
